import { AvatarGroupProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: AvatarGroupProps = {
  items: [
    {
      ariaLabel: 'Avatar for John Doe',
      name: 'John Doe',
      title: 'Wix Account: John Doe (johndoe@gmail.com)',
    },
    {
      ariaLabel: 'Avatar for John Doe',
      name: 'John Doe',
      title: 'Wix Account: John Doe (johndoe@gmail.com)',
    },
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as AvatarGroupProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
